import React, {Suspense} from "react";
import {createRoot} from "react-dom/client";

class ContainerHead {
  constructor(element: HTMLElement) {
    const root = createRoot(element);
    root.render(
      <Suspense fallback={null}>
        <ContainerHeadline elem={element} />
      </Suspense>,
    );
  }
}

const ContainerHeadline: React.FC<{elem: HTMLElement}> = ({elem}) => {
  const {containerTitle, containerLinkText, containerLinkUrl} = elem.dataset;

  return (
    <div className="container__title mb-5">
      {containerTitle && <h2 className="mb-0">{containerTitle}</h2>}
      {containerLinkText && containerLinkUrl && (
        <a className="link link-icon ml-0 ml-m-3" href={containerLinkUrl}>
          {containerLinkText}
          <i className="icon icon-right--blue ml-3"></i>
        </a>
      )}
    </div>
  );
};
export default ContainerHead;
